export const Headers = {
  APP: 'x-lwtears-app',
  APP_VERSION: 'x-lwtears-app-version',
  APP_BUILD: 'x-lwtears-app-build',
  APP_SESSION: 'x-lwtears-session',
  APP_LOCALE: 'x-lwtears-locale'
};
